export const HowItWorks = () => {
  return (
    <div>
      <h3 className="text-lg font-medium mb-4">How This Works</h3>
      <div className="bg-accent/50 p-4 rounded-lg">
        <ol className="list-decimal list-inside space-y-2 text-gray-700">
          <li>Go through the step by step which will ask you for key pieces of information</li>
          <li>Copy the prompt to use in a tool of your choice</li>
          <li>Download the reference file</li>
          <li>Paste the prompt in the tool of your choice</li>
          <li>Upload the reference file</li>
          <li>Hit Enter</li>
        </ol>
      </div>
    </div>
  );
};